/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import { useMemo } from 'react'
import { Table, Spin } from 'antd'
import colors from '@sportninja/common/constants/appColors'
import { useCouponColumns } from './useCouponColumns'
import { getTableStyles } from '../../../../styles/tableStyles'
import useWindowSize from '../../../../hooks/useWindowSize'

type CouponTableProps = {
  coupons: any[]
  isLoading: boolean
  currencyCode: string
  scheduleId?: string
  organizationId?: string
  onEdit: (record: any) => void
  onDelete: (record: any) => Promise<void>
  onCopy: (record: any) => void
}

export default function CouponTable({
  coupons,
  isLoading,
  currencyCode,
  scheduleId,
  organizationId,
  onEdit,
  onDelete,
  onCopy,
}: CouponTableProps) {
  const { width } = useWindowSize()
  const isMobile = useMemo(() => width < 1024, [width])

  const columns = useCouponColumns({
    currencyCode,
    scheduleId,
    organizationId,
    onEdit,
    onDelete,
    onCopy,
  })

  return (
    <div
      css={css`
        width: 100%;
        margin-top: 24px;
      `}
    >
      {isLoading && coupons.length === 0 ? (
        <div
          css={css`
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: 200px;
          `}
        >
          <Spin
            size='small'
            css={css`
              .ant-spin-dot-item {
                background-color: ${colors.PRIMARY};
              }
            `}
          />
        </div>
      ) : (
        <Table
          columns={columns}
          dataSource={coupons}
          rowKey={(item) => item.id}
          pagination={false}
          size='small'
          scroll={{ x: 'max-content' }}
          css={getTableStyles(isMobile)}
        />
      )}
      {isLoading && coupons.length > 0 && (
        <div
          css={css`
            display: flex;
            justify-content: center;
            padding: 20px;
          `}
        >
          <Spin
            size='small'
            css={css`
              .ant-spin-dot-item {
                background-color: ${colors.PRIMARY};
              }
            `}
          />
        </div>
      )}
    </div>
  )
}
